import { NavigationItem } from '@/types/navigation';
import { SideNavLinks } from './SideNavLinks';

export const SideNavFooterLinks = ({ navItems }: { navItems: NavigationItem[] }) => (
  <div className="[&_ul]:pb-0">
    <SideNavLinks navItems={navItems} />
  </div>
);
